import React, { useMemo } from "react";
import { FiltersTypes } from "@common/types/filters/general";
import { WhoPaysOption, whoPaysLabels } from "@common/types/filters/clients";
import { useActiveOrganization } from "@hooks/useActiveOrganization";
import { BreakableText } from "@design-system/BreakableText/BreakableText";
import { formatFilterLabelText } from "./formatFilterLabel";

interface Props {
    filters: FiltersTypes;
}

export const WhoPaysFilterLabel: React.FC<Props> = ({ filters }) => {
    const activeOrganization = useActiveOrganization();
    const { whoPays } = filters;

    const labels = useMemo(() => {
        if (!whoPays || whoPays.length === 0) {
            return [];
        }

        return whoPays.map((option) => {
            if (option === WhoPaysOption.ORGANIZATION) {
                return activeOrganization?.name ?? "My firm";
            }
            return whoPaysLabels[option];
        });
    }, [whoPays, activeOrganization?.name]);

    const text = formatFilterLabelText(labels, "Payers");

    if (text === null) {
        return null;
    }

    return <BreakableText text={text} />;
};
